import { Component, inject } from '@angular/core';
import { SharedUiModule } from '@stc-apps/shared-ui';
import { LoaderService } from '../../../core/services/loader.service';
import { CommonModule } from '@angular/common';
import { map } from 'rxjs';

@Component({
  selector: 'stc-apps-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [SharedUiModule, CommonModule],
})
export class LoaderComponent {
  private loaderService = inject(LoaderService);

  // raw state
  loaderType$ = this.loaderService.loaderType$;

  // ✅ visibility state (THIS FIXES YOUR ISSUE)
  showLoader$ = this.loaderType$.pipe(map((type) => type !== 'none'));

  loadingStates = [
    {
      text: 'Load CTK',
    },
    {
      text: 'Configure API URL ',
    },
    {
      text: 'Execute test Cases',
    },
    {
      text: 'Construct Reports ',
    },
  ];
}
